import { Component, Input, OnInit } from '@angular/core';
import { CurrentOrdersService } from '../../../../core/services/current-orders.service';
import { LiveOrders } from '../../../../core/models/live-order.model';
import { ItemType } from '../../../../core/enums/item.enum';

@Component({
  selector: 'app-current-orders-ready',
  templateUrl: './current-orders-ready.component.html',
  styleUrls: ['./current-orders-ready.component.scss'],
})
export class CurrentOrdersReadyComponent implements OnInit {
  @Input() public isGroup: boolean;
  @Input() public isSpecial: boolean;
  public currentOrders: LiveOrders = new LiveOrders();
  public itemType = ItemType;

  constructor(
    private currentOrderService: CurrentOrdersService
  ) { }

  ngOnInit() {
    this.getOrders();
  }

  public getOrders(): void {
    this.currentOrderService.getCurrentOrders()
      .subscribe(orders => {
        this.currentOrders = orders;
      });
  }

}
